import { useTranslations } from '@lang';
import moment from 'moment';
import { Item } from 'shared-types';
import { pluralizeAdults, pluralizeChildren } from '../BasketDrawer.helpers';
import { BasketDrawerTextWrapper, BasketItemText, Listing } from '../BasketDrawer.styles';

export const DiningListing = ({ tables }: { tables: Item[] }) => {
  const { t } = useTranslations();
  return (
    <Listing>
      {tables?.map((table) => {
        return (
          <div data-testid="dining-listing" key={table.id}>
            <BasketDrawerTextWrapper>
              {moment(table?.checkIn).format('ddd, D MMM')} -{' '}
              {moment(table?.checkIn).format('HH:mm')}
            </BasketDrawerTextWrapper>
            <BasketDrawerTextWrapper marginBottom="10px">
              <BasketItemText>{table?.bookable?.ids?.restaurantName}</BasketItemText>
              <BasketItemText>
                {table.adults} {pluralizeAdults(table?.adults ?? 1, t)}
              </BasketItemText>
              {!!(table.children && table.children > 0) && (
                <BasketItemText>
                  {table?.children} {pluralizeChildren(table.children, t)}
                </BasketItemText>
              )}
            </BasketDrawerTextWrapper>
          </div>
        );
      })}
    </Listing>
  );
};
